import { CalibrationData, CalibrationDataActions } from './types';

export const getCalibrationDataRequest = (searchText?: string) => ({
    type: CalibrationDataActions.CALIBRATION_DATA_REQUEST,
    searchText,
});

export const getCalibrationDataSuccess = (data: CalibrationData) => ({
    type: CalibrationDataActions.CALIBRATION_DATA_SUCCESS,
    payload: data,
});

export const getCalibrationDataFailure = (error: unknown) => ({
    type: CalibrationDataActions.CALIBRATION_DATA_FAILURE,
    payload: error,
});

export const accessCalibrationDataFailure = (error: unknown) => ({
    type: CalibrationDataActions.CALIBRATION_DATA_FAILURE_ACCESS,
    payload: error,
});

export const setCurrentPage = (pageNo: number) => ({
    type: CalibrationDataActions.SET_CURRENT_PAGE,
    pageNo,
});

export const setHitsPerPage = (hitsPerPage: number) => ({
    type: CalibrationDataActions.SET_HITS_PER_PAGE,
    hitsPerPage,
});

export const resetState = () => ({
    type: CalibrationDataActions.RESET_STATE,
});

export const removeAccessError = () => ({
    type: CalibrationDataActions.REMOVE_ACCESS_ERROR,
});

export const removeDownloadError = () => ({
    type: CalibrationDataActions.REMOVE_DOWNLOAD_ERROR,
});
